<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/Account/Shared/SharedImagePlaceholder.vue
// IDS-219: change placeholder image
const props = withDefaults(
    defineProps<{
        size?: 'xs' | 'sm' | 'md' | 'lg';
    }>(),
    {
        size: 'md',
    },
);

const sizeMap: Record<string, number> = {
    xs: 8,
    sm: 16,
    md: 36,
    lg: 64,
};

const imageSize = computed(() => sizeMap[props.size]);
</script>

<template>
    <div class="flex aspect-square h-full w-full items-center">
        
<FormKitLazyProvider config-file="true">
<FormKitIcon
            icon="logo-grey"
            class="mx-auto block text-gray-dark"
            :class="`h-${imageSize} w-${imageSize}`"
        />
</FormKitLazyProvider>

    </div>
</template>
